import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import Logo from '../Components/Logo';
import CardOfCase from '../Components/CardOfCase';

import stylesLogo from '../styles/Logo.module.css';

const PageOfCase = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const handleBack = () => {
        const currentPath = location.pathname;
        const previousPath = window.history.state && window.history.state.idx > 0 ? window.history.state.idx - 1 : null;

        if (previousPath !== null && previousPath !== currentPath) {
            navigate(-1);
        } else {
            navigate("/home");
        }
    };
   
    return (
    <>
        <a style={{zIndex: '9999'}} className={stylesLogo.widthLimitation}><Logo to='/' position='fixed' /></a>
        <CardOfCase closeModal={handleBack} id={id} onCardOfCaseSuccess={()=>{}} isPage={true} />
    </>
    )
}

export default PageOfCase;